import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import TickRow from 'pages/Installments/Mahsa/Components/TickRow';

const useStyles = makeStyles(() => ({
	root: {
		border: '1px solid #E9E9F0',
		borderRadius: '8px',
		padding: '12px',
	},
	hr: {
		color: '#E9E9F0',
		margin: '12px 0',
		width: '100%',
		border: '1px solid #E9E9F0',
	},
}));

const Card = ({ title }) => {
	const classes = useStyles();
	return (
		<Grid container>
			<Grid item xs={12} className={classes.root}>
				<Grid container>
					{title && (
						<Grid item xs={12}>
							<Typography style={{ fontSize: '14px', fontWeight: 700, color: '#101740' }}>{title}</Typography>
						</Grid>
					)}
					<Grid item xs={12} style={{ marginTop: '15px' }}>
						<TickRow title={'مبلغ پرداخت شده دی:'} price={'۳,000,000'} colorTitle={'#888BA0'} />
						<Box className={classes.hr} />
						<TickRow title={'مبلغ پرداخت شده دی:'} price={'۳,000,000'} colorTitle={'#888BA0'} />
						<Box className={classes.hr} />
						<TickRow title={'مبلغ پرداخت شده دی:'} price={'۳,000,000'} colorTitle={'#888BA0'} />
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Card;
